import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UserDetailsService } from '../../services/user-details.service';
import { BadgeComponent, ButtonComponent, CardComponent, IconComponent, MenuContentComponent, MenuDirective, ModalService, NotificationService } from '@pansa/ui';
import { GroupColorPipe } from '@app/features/groups/pipes/group-color.pipe';
import { Router } from '@angular/router';
import { BlockUserDTO, UserDTO } from '../../models/user.model';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'rqa-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CardComponent, ButtonComponent, IconComponent, BadgeComponent, GroupColorPipe, MenuContentComponent, MenuDirective]
})
export class UserDetailsComponent {
  readonly userDetailsService = inject(UserDetailsService);
  private router = inject(Router);
  private modalService = inject(ModalService);
  private userService = inject(UserService);
  private notificationService = inject(NotificationService);
  user = this.userDetailsService.user;

  onEdit(username: string | undefined): void {
    this.router.navigate(['/users/edit', username]);
  }

  onDelete(): void {
    this.modalService.openModal({
      type: 'warning',
      destructive: true,
      title: `Czy chcesz usunąć konto użytkownika ${this.user()?.firstName} ${this.user()?.lastName}?`,
      subTitle: 'Usunięcie użytkownika jest trwałe',
      submitText: 'Tak, usuń',
      cancelText: 'Anuluj',
      onSubmit: () => this.deleteUser(this.user()?.username as string)
    });
  }

  onBlock(): void {
    const user = this.user() as UserDTO;
    const title = user.enabled ? `Czy chce zablokować konto użytkownika ${user.firstName} ${user.lastName}?` : `Czy chce odblokować konto użytkownika ${user.firstName} ${user.lastName}?`
    const submitText = user.enabled ? 'Tak, zablokuj' : 'Tak odblokuj';
    this.modalService.openModal({
      type: 'warning',
      destructive: true,
      title: title,
      submitText: submitText,
      cancelText: 'Anuluj',
      onSubmit: () => this.blockUser(user)
    });
  }

  private blockUser(user: UserDTO): void {
    const blockMesssage = user.enabled ? 'Zablokowano' : 'Odblokowano';
    const payload: BlockUserDTO = { enabled: !user.enabled, username: user.username };
    this.userService.blockUser(payload).subscribe(res => {
      this.notificationService.success({title: 'Sukces', subTitle: `${blockMesssage} użytkownika ${payload.username}`});
      this.userService.refreshUsers();
      this.userDetailsService.close();
    });
  }

  private deleteUser(username: string): void {
    this.userService.deleteUser(username).subscribe((res) => {
      this.notificationService.success({ title: 'Sukces', subTitle: `Usunięto użytkownika ${username}` });
      this.userDetailsService.close();
      this.userService.refreshUsers();
    });
  }
}
